// Vollea — Rankings (global)
import React, { useEffect, useState } from "react";
import { IoPodium } from "react-icons/io5";
import { Header, Empty, Avatar } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

export default function Rankings() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await api.get("/rankings");
        // Backend returns either {leagues:[]} or a flat array — be defensive.
        if (Array.isArray(data)) {
          setRows(data);
        } else if (data && Array.isArray(data.leagues) && data.leagues.length > 0) {
          setRows(data.leagues[0].table || []);
        } else {
          setRows([]);
        }
      } catch { setRows([]); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div style={{ background: C.bg, minHeight: "100vh", paddingBottom: 90 }}>
      <Header title="Rankings" subtitle="Top players on Vollea" testid="rankings-page-title" />
      <div style={{ padding: `0 ${SP.lg}px` }}>
        <div style={{ display: "flex", alignItems: "center", paddingBottom: SP.sm, borderBottom: `1px solid ${C.border}` }}>
          <div style={{ width: 28, color: C.textMuted, fontSize: 11, fontWeight: 700, textAlign: "center" }}>#</div>
          <div style={{ flex: 1, color: C.textMuted, fontSize: 11, fontWeight: 700 }}>PLAYER</div>
          <div style={{ width: 40, color: C.textMuted, fontSize: 11, fontWeight: 700, textAlign: "center" }}>WIN%</div>
          <div style={{ width: 44, color: C.textMuted, fontSize: 11, fontWeight: 700, textAlign: "center" }}>PTS</div>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", color: C.lime, padding: SP.xl }}>Loading…</div>
        ) : rows.length === 0 ? (
          <Empty icon={<IoPodium size={36} color={C.textDim} />} text="No ranked players yet — play and confirm matches to populate this table." testid="rankings-empty" />
        ) : (
          <div data-testid="rankings-table">
            {rows.map((r, i) => {
              const rank = r.rank || i + 1;
              const top = rank <= 3;
              return (
                <div key={r.user_id} style={{ display: "flex", alignItems: "center", padding: `${SP.md}px 0`, borderBottom: `1px solid ${C.divider}`, background: top ? C.surface2 : "transparent", borderRadius: top ? R.sm : 0 }}>
                  <div style={{ width: 28, color: top ? C.lime : C.text, fontWeight: 700, fontSize: 14, textAlign: "center" }}>{rank}</div>
                  <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                    <Avatar uri={r.photo} name={r.name} size={30} />
                    <div style={{ color: C.text, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.name}</div>
                  </div>
                  <div style={{ width: 40, color: C.text, fontSize: 14, textAlign: "center" }}>{r.win_percentage ?? 0}%</div>
                  <div style={{ width: 44, color: C.lime, fontWeight: 700, fontSize: 14, textAlign: "center" }}>{r.points ?? 0}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
